"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mockApolloClient = _interopRequireDefault(require("../_mockApolloClient.js"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TableBuilder = function TableBuilder(props) {
  var getColumnRenderer = function getColumnRenderer(value, renderer) {
    // TODO
    switch (renderer) {
      case 'abs':
        return value;
      case 'percent':
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, value, "%");
      case 'xy':
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, value, "/", value);
      default:
        return value;
    }
  };
  var columns = props.columns.map(function (column) {
    return {
      name: column.id,
      label: column.label,
      render: function render(_ref) {
        var value = _ref.value;
        return getColumnRenderer(value, column.render);
      },
      tooltip: column.tooltip ? column.description : undefined,
      sort: true
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    apolloClient: props.isPreview ? _mockApolloClient["default"] : undefined,
    query: props.query,
    columns: columns
  });
};
var _default = exports["default"] = TableBuilder;